module.exports = __webpack_public_path__ + "img/54.83ffff5d.jpg";